<div class="header">
  @if (!embedService.embed && colorService.logoSrc) {
    <a class="logo" [routerLink]="colorService.companyId ? ['/companies', colorService.companyId] : ['']">
      <img [src]="colorService.logoSrc" alt="logo">
    </a>
  }
  <div class="links">
    @if (!embedService.embed && showWebsite()) {
      <a
        class="topbar-item"
        [href]="seoService.website"
        target="_blank"
        [attr.aria-label]="'jobboard.static.header.website' | transloco"
      >
        <fa-icon [icon]="fontawesomeService.solid.externalLinkAlt"></fa-icon>
        <span class="topbar-label">{{ 'jobboard.static.header.website' | transloco }}</span>
      </a>
    }

    <ct-lib-dropdown [dropdown]="languageDropdown" [autowidth]="true" alignment="right" [closeOnClick]="true">
      <button
        type="button"
        class="topbar-item"
        [attr.aria-label]="'jobboard.static.header.language' | transloco"
      >
        <fa-icon [icon]="icons.globe"></fa-icon>
        <span class="topbar-label">{{ languageService.currentLanguage?.name }}</span>
      </button>
    </ct-lib-dropdown>
    <ng-template #languageDropdown>
      <div class="topbar-panel">
        <ul
          class="topbar-menu"
          role="menu"
          [attr.aria-label]="'jobboard.static.header.language-menu' | transloco"
        >
          @for (lang of languages; track lang.value) {
            <li role="none">
              <button
                type="button"
                class="topbar-option"
                role="menuitemradio"
                [attr.aria-checked]="languageService.currentLanguage?.value === lang.value"
                (click)="languageService.setLanguage(lang.value)"
              >
                <span>{{ lang.name }}</span>
                @if (languageService.currentLanguage?.value === lang.value) {
                  <span class="topbar-dot" aria-hidden="true"></span>
                }
              </button>
            </li>
          }
        </ul>
      </div>
    </ng-template>

    @if (loggedIn()) {
      <a
        class="topbar-item"
        [routerLink]="['/dashboard']"
        [attr.aria-label]="'jobboard.static.header.platform' | transloco"
      >
        <fa-icon [icon]="icons.switch"></fa-icon>
        <span class="topbar-label">{{ 'jobboard.static.header.platform' | transloco }}</span>
      </a>
    } @else {
      <button type="button" class="topbar-item" (click)="openLogin()">
        {{ 'jobboard.static.header.login' | transloco }}
      </button>
    }
  </div>
</div>
<app-platform-apply-with-profile-modal />
